import Api from '@/services/Api';

export default {
  disabledTransmittingPower(version) {
    if (version) {
      return !version.changeTransmittingPower;
    }
    return true;
  },
};
